import { createResource, type Match, type Query } from '@atlassian/react-resource-router';
import { getProjectKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch';

export type IssueHideEmptyFields = {
	id: string;
	currentState: boolean;
	projectKey: string;
};

export type IssueHideEmptyFieldsData = {
	[id: string]: IssueHideEmptyFields;
};

const getKey = ({ match, query }: { match: Match; query: Query }) => {
	const projectKey = getProjectKey(match, query);
	return `issue.hide-empty-fields.${projectKey}`;
};

export const issueHideEmptyFieldsDataResource = createResource<
	IssueHideEmptyFieldsData | undefined
>({
	type: 'ISSUE_HIDE_EMPTY_FIELDS_DATA',
	getKey,
	getData: async ({ match, query }) => {
		const key = getKey({ match, query });
		const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
		return performGetRequest(requestUrl);
	},
	isBrowserOnly: false,
});
